import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
/**
 * @description
 * This module manages the state of the snackbar modal.
 * 
 * @usage
 * 
 * '@\components\SnackbarModal\SnackbarModal' have to be included
 * globally in the app, for example: in '@\App'.
 * 
 * To initialize the snackbar, call the action initSnackbar(payload),
 * where "payload" is an object with the following format:
 
 let payload = {
    typeMessage: '', // values accepted: 'success', 'error', 'warning', 'info'. Set to another value for a normal light-black background snackbar.
    message: {
        title: 'title message', // set to null for a small snackbar.
        body: 'body message',
    },
    timeout: 1000, // Value in milliseconds. Set to 0 for a snackbar that will never close automatically.
    showProgress: false, // set to true to show a progress/loading animation on the right of the snackbar.
    showCloseBtn: true, // set to false to hide the close button
    closeBtnMessage: 'cerrar', // message showed in close button
    }
 * 
 * This component is in beta, more options soon ;)
 */
const SnackbarModalModule = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default SnackbarModalModule